import SearchResults from './SearchResults';

export { type SearchResultsProps } from './SearchResults';
export default SearchResults;
